import { tabProps } from "@/utils/globalPropsTypes";
import { Form, InputNumber, Radio, Select } from "antd";

const GaugeTab = ({ editItem }) => {
  const is = (types) => types.includes(editItem?.component);

  return (
    <>
      {is(["tank"]) && (
        <Form.Item name="capacity" label="Capacity" getValueFromEvent={(v) => v || 1}>
          <InputNumber min={1} className="w-100" />
        </Form.Item>
      )}

      {is(["dial"]) && (
        <Form.Item
          name="dialType"
          label="Gauge Design Type"
          initialValue="props"
          rules={[{ required: true, message: "Gauge Type" }]}
        >
          <Select
            options={[
              { label: "Default Gauge", value: "props" },
              { label: "Simple Gauge", value: "simple" },
              { label: "Gradient Arc Gauge", value: "gradient" },
              { label: "Temperature Gauge", value: "temperature" },
              { label: "Gauge Chart With 20 Levels", value: "levels" },
              { label: "Gauge Chart With Custom Colors", value: "custom" },
            ]}
          />
        </Form.Item>
      )}

      {is(["dial", "thermometer"]) && (
        <>
          <Form.Item
            name="min"
            label="Enter Min Value"
            initialValue={0}
            getValueFromEvent={(v) => (Number(v) >= 0 ? v : undefined)}
            rules={[{ required: true, message: "Please Input Min" }]}
          >
            <InputNumber min={0} className="w-100" />
          </Form.Item>

          <Form.Item
            name="max"
            label="Enter Max Value"
            initialValue={100}
            getValueFromEvent={(v) => v || undefined}
            rules={[{ required: true, message: "Please Input Max" }]}
          >
            <InputNumber min={0} className="w-100" />
          </Form.Item>
        </>
      )}

      {is(["thermometer"]) && (
        <Form.Item name="unit" label="Unit" initialValue="celsius">
          <Radio.Group>
            <Radio value="celsius">Celsius</Radio>
            <Radio value="fahrenheit">Fahrenheit</Radio>
          </Radio.Group>
        </Form.Item>
      )}
    </>
  );
};

export default GaugeTab;

GaugeTab.propTypes = tabProps;
